import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import {Feature} from 'ol';
import {Vector as VectorLayer} from 'ol/layer';
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import {ApiService} from '@modules/shared/services/api.service';
import {ToastrService} from 'ngx-toastr';
import Overlay from 'ol/Overlay';
import {Fill, Icon, Stroke, Style, Text} from 'ol/style';
import {LineString} from 'ol/geom';
import {serverCoordinatesToOlMap, typeLabels} from '@modules/shared/shared.component';
import {forkJoin} from 'rxjs';
import {Stamen} from 'ol/source';
import { environment } from '@env/environment';
import {TranslocoService} from '@ngneat/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalSearchMapComponent } from './modal-search-map/modal-search-map.component';
import { ModalListResourcesComponent } from './modal-list-resources/modal-list-resources.component';
@Component({
  selector: 'app-explore-resources',
  templateUrl: './explore-resources.component.html',
  styleUrls: ['./explore-resources.component.css']
})
export class ExploreResourcesComponent implements OnInit, OnDestroy {
  typeLabels = typeLabels;
  @ViewChild('popupElement', {static: false}) popupElementComponent;
  map: Map;
  searchMode = 0;
  resources = [];
  shownResources = [];
  quickSearchString = '';
  formAdvancedSearch = {
    title: '',
    keywords: '',
    coverage: '',
    description: '',
    rights: '',
    source: '',
    categories: '',
    multimedia_type: '',
    author: '',
    publisher: '',
    coordinates: '',
    format: '',
  };
  iconsPoints = [];
  fixedPoints = [];
  borderItems = [];
  vectorLayer: VectorLayer<any>;
  vectorSource: VectorSource;
  fromBackButton = false;
  commonPlaces;
  noResourcesString;
  viewResourceString;
  typeString;
  activeSearch = false;
  isCollapsed = true;
  constructor(private apiService: ApiService,
              private toastr: ToastrService,
              private translocoService: TranslocoService,
              private modalService: NgbModal) {
    translocoService.langChanges$.subscribe(lang => {
      this.translocoService.load(lang).subscribe(value => {
          this.noResourcesString = this.translocoService.translate('common.no_resources_in_place');
          this.viewResourceString = this.translocoService.translate('common.view_resource');
          this.typeString = this.translocoService.translate('common.type');
      });
    });
  }
  ngOnDestroy(): void {
    this.modalService.dismissAll();
  }

  ngOnInit() {
    this.noResourcesString = this.translocoService.translate('common.no_resources_in_place');
    this.viewResourceString = this.translocoService.translate('common.view_resource');
    this.typeString = this.translocoService.translate('common.type');
    this.getInfo();
  }
  generateMap() {
    const container = document.getElementById('popup');
    const content = document.getElementById('popup-content');
    const closer = document.getElementById('popup-closer');


    const overlay = new Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      }
    });

    function pointStyleFunction(feature, resolution) {
      return new Style({
        text: new Text({
          textAlign: 'center',
          textBaseline: 'top',
          font: 'Arial',
          scale: 1.2,
          text: 'Sahara Occidental',
          fill: new Fill({color: '#121212'}),
        })
      });
    }

    function borderStyleFunction(feature, resolution) {
      return new Style({
        stroke: new Stroke({
          color: '#96968d',
          width: 3,
          lineCap: 'square',
          lineDash: [4, 7]
        })
      });
    }

    function borderStyleFunction2(feature, resolution) {
      let color = '';
      let src = '';
      if (feature.get('multimediaType') === 'video') {
        color = '#4372c9';
        src = 'assets/images/video.png';
      } else if (feature.get('multimediaType') === 'audio') {
        color = '#c00d0d';
        src = 'assets/images/audio.png';
      } else if (feature.get('multimediaType') === 'document') {
        color = '#7ce38d';
        src = 'assets/images/document.png';
      } else {
        color = '#ffc956';
        src = 'assets/images/camara.png';
      }
      return new Style({
        image: new Icon({
          src: src,
          scale: 0.4,
          anchor: [0.5, 100],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
        })
      });
    }

    this.iconsPoints = this.resources.filter(
      r => r.common_place === '' || r.common_place === undefined || r.common_place === null).map(item => {
      const cn = serverCoordinatesToOlMap(item['coordinates']);
      return new Feature({
        geometry: new Point(olProj.fromLonLat(cn)),
        name: item['title'],
        multimediaType: item['multimedia_type'],
        id_resource: item['id'],
        type: 'resource'
      });
    });
    function borderStyleFunctionCommon(feature, resolution) {
      return new Style({
        image: new Icon({
          src: 'assets/images/common.png',
          scale: 0.4,
          anchor: [0.5, 100],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
        })
      });
    }
    const commonPlacesPoints = [];
    for (const item of this.commonPlaces) {
      if (this.getCommonPlaceResources(item['label']).length !== 0) {
        const cn = serverCoordinatesToOlMap(item['coordinates']);
        const f =  new Feature({
          geometry: new Point(olProj.fromLonLat(cn)),
          name: item['label'],
          type: 'common'
        });
        commonPlacesPoints.push(f);
      }
    }
    const saharaFixedPoint =  new Feature({
      geometry: new Point(olProj.fromLonLat([-13.2154, 24.9215])),
      name: 'Sahara',
      type: 'fixed'
    });

    const borderLine = new Feature({
      geometry: new LineString([olProj.fromLonLat([-13.172624970064488, 27.667259406704968]),
        olProj.fromLonLat([-8.667611389974295, 27.667259406704968])]),
      name: 'Sahara',
      type: 'fixed'
    });

    this.fixedPoints.push(saharaFixedPoint);
    this.borderItems.push(borderLine);
    this.vectorSource = new VectorSource({
      features: [...this.iconsPoints],
    });
    const fixedSource = new VectorSource({
      features: [...this.fixedPoints],
    });
    const borderSource = new VectorSource({
      features: [...this.borderItems],
    });
    const commonPlacesSource = new VectorSource({
      features: [...commonPlacesPoints]
    });
    this.vectorLayer = new VectorLayer({
      source: this.vectorSource,
      style: borderStyleFunction2
    });
    const fixedLayer = new VectorLayer({
      source: fixedSource,
      style: pointStyleFunction
    });
    const borderLayer = new VectorLayer({
      source: borderSource,
      style: borderStyleFunction
    });
    const commonPlacesLayer = new VectorLayer({
      source: commonPlacesSource,
      style: borderStyleFunctionCommon
    });
    let source;
    if (environment.client.mapType === 'terrain'){
      source = new Stamen({
        layer: 'terrain',
      });
    } else {
      source = new OSM({
      })
    }
    this.map = new Map({
      target: 'hotel_map',
      layers: [
        new TileLayer({
          source: source
        }),
        this.vectorLayer, commonPlacesLayer, borderLayer
      ],

      overlays: [overlay],
      view: new View({
        center: olProj.fromLonLat(environment.client.mapCoordinates),
        zoom: environment.client.mapZoom
      })
    });
    this.map.on('singleclick',  (evt: any) => {
      const feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature2) {
        return feature2;
      });
      if (feature && feature.get('type') === 'resource') {
        const coordinate = evt.coordinate;
        const hdms = feature.get('name');

        content.innerHTML = '<h3>' + feature.get('name') + '</h3>';
        content.innerHTML += '<p><b>' + this.typeString + ':&nbsp;</b>' +  this.getTypeLabels(feature.get('multimediaType')) + '</p>';
        content.innerHTML += '<a href="/recursos/ver/' + feature.get('id_resource') +  '">' + this.viewResourceString + '</a>';
        overlay.setPosition(coordinate);
      } else if (feature && feature.get('type') === 'common') {
        const coordinate = evt.coordinate;
        const hdms = feature.get('name');
        content.innerHTML = '<h3>' + feature.get('name') + '</h3>';
        const commonRes = this.getCommonPlaceResources(feature.get('name'));
        if (commonRes.length > 0) {
          content.innerHTML += '<ul>';
          content.innerHTML += '<p><b>Recursos:</b></p>';
          for (const res of commonRes) {
            content.innerHTML += '<li style="margin-left: 1rem;"><a href="/recursos/ver/' + res.id +  '">'
              + res.title + '&nbsp;(' + typeLabels[res.multimedia_type] + ')' +  ' </li></a>';
            content.innerHTML += '';
          }
          content.innerHTML += '</ul>';
        } else {
          content.innerHTML += '<p>' + this.noResourcesString + '</p>';
        }


        overlay.setPosition(coordinate);
      }
    });


    closer.onclick = function () {
      overlay.setPosition(undefined);
      closer.blur();
      return false;
    };
  }
  getCommonPlaceResources(commonPlace: string) {
    return this.resources.filter(r => r.common_place === commonPlace);
  }

  recreatePoints() {
    this.iconsPoints = this.resources.filter(
      r => r.common_place === '' || r.common_place === undefined || r.common_place === null).map(item => {
      const cn = serverCoordinatesToOlMap(item['coordinates']);
      return new Feature({
        geometry: new Point(olProj.fromLonLat(cn)),
        name: item['title'],
        multimediaType: item['multimedia_type'],
        id_resource: item['id'],
        type: 'resource'
      });
    });
    this.vectorSource = new VectorSource({
      features: [...this.iconsPoints],
    });
    this.vectorLayer = new VectorLayer({
      source: this.vectorSource,
    });
    const l = this.map.getLayers().getArray()[1];
    // @ts-ignore
    l.setSource(this.vectorSource);
  }



  getInfo() {
    forkJoin([this.apiService.getAllResources(), this.apiService.getCommonPlaces()]).subscribe(([rRes, cRes]) => {
      if (rRes.success && cRes.success) {
        this.resources = rRes.data;
        this.commonPlaces = cRes.data;
        this.resources.map(r => r.shownType = typeLabels[r.multimedia_type]);
        this.generateMap();
      } else {
        this.toastr.error('Error interno');
      }
    });
  }

  quickSearch(quickSearchString: string) {
    this.apiService.quickSearch({query: quickSearchString}).subscribe(response => {
      this.activeSearch = true;
      this.resources = response.data;
      this.resources.map(r => r.shownType = typeLabels[r.multimedia_type]);
      this.recreatePoints();
    }, error => {
      this.toastr.error('', 'Error interno obteniendo información.');
    });
  }
  advancedSearch(formAdvancedSearch: any) {
    this.apiService.advancedSearch(formAdvancedSearch).subscribe(response => {
      this.activeSearch = true;
      this.resources = response.data;
      this.resources.map(r => r.shownType = typeLabels[r.multimedia_type]);
      this.recreatePoints();
    }, error => {
      this.toastr.error('', 'Error interno obteniendo información.');
    });
  }
  clearSearch() {
    this.apiService.getAllResources().subscribe(response => {
      this.activeSearch = false;
      this.resources = response.data;
      this.resources.map(r => r.shownType = typeLabels[r.multimedia_type]);
      this.quickSearchString = '';

      Object.keys(this.formAdvancedSearch).forEach(key => {
        this.formAdvancedSearch[key] = '';
      });
      this.recreatePoints();
    }, error => {
      this.toastr.error('', 'Error interno obteniendo información.');
    });
  }
  getTypeLabels(type: string) {
    if (type === 'photo') {
      return this.translocoService.translate('common.photo');
    } else if (type === 'audio') {
      return this.translocoService.translate('common.audio');
    } else if (type === 'video') {
      return this.translocoService.translate('common.video');
    } else if (type === 'document') {
      return this.translocoService.translate('common.document');
    }
  }
  openSearchModal() {
    const modal = this.modalService.open(ModalSearchMapComponent, { size: 'lg', backdrop: 'static' });
    modal.result.then((result) => {
      if (result.msg === 'quick') {
        this.quickSearch(result.data)
      } else if (result.msg === 'advanced') {
        this.advancedSearch(result.data)
      }
    });
  }
  openResourcesModal() {
    const modal = this.modalService.open(ModalListResourcesComponent, { size: 'lg', backdrop: 'static' });
    modal.componentInstance.resources = this.resources;
    modal.result.then((result) => {
      if (result.msg === 'quick') {
        this.quickSearch(result.data)
      } else if (result.msg === 'advanced') {
        this.advancedSearch(result.data)
      }
    });
  }
}
